import React from 'react';
import { getLocalizedDateTime } from '../../localization/LocalizedString';
import './ServiceTable.css';

const DatapickListItem = ({ currentLanguage, item }) => {
  const {
    userId,
    employeeId,
    date,
    siteId,
    serviceSite,
    productId,
    orderAmount,
    datapickService,
  } = item;

  const {
    companyName,
    city,
    streetAddress,
    customer,
  } = serviceSite.destination;

  const {
    name,
  } = customer;

  const datapickServiceName = datapickService.map((serviceName) => (currentLanguage === 'en' ? serviceName.datapickServiceName.en_US : serviceName.datapickServiceName.fi_FI));

  return (
    <tr className="report-table-row_service">
      <th className="report-table-cell_service">{userId}</th>
      <th className="report-table-cell_service">{employeeId}</th>
      <th className="report-table-cell_service">{getLocalizedDateTime(new Date(date), currentLanguage)}</th>
      <th className="report-table-cell_service">{name}</th>
      <th className="report-table-cell_service">{companyName}</th>
      <th className="report-table-cell_service">{streetAddress}</th>
      <th className="report-table-cell_service">{city}</th>
      <th className="report-table-cell_service">{siteId}</th>
      <th className="report-table-cell_service">{datapickServiceName}</th>
      <th className="report-table-cell_service">{productId}</th>
      <th className="report-table-cell_service">{orderAmount}</th>
    </tr>
  );
};

export default DatapickListItem;



// WEBPACK FOOTER //
// ./src/components/servicereport/DatapickListItem.js